(function ($, Drupal, once, drupalSettings) {
    "use strict";
    Drupal.behaviors.global  = {
      attach: function (context, settings) {
 
// read more button functionality
let leadershipGridIR = document.querySelectorAll(".leadership-grid-container");
if (leadershipGridIR.length) {
  leadershipGridIR.forEach((elem) => {
    let readBio = false;
    let bioInfo = elem.querySelectorAll('.bio-info');
    bioInfo.forEach((bio) => {
      bio.addEventListener('click', function (el) {
        if (this.classList.contains('btn-plus-icon')) {
          readBio = true;
        }
        let bioContainer = this.previousElementSibling;
        closeAllBio(bioInfo);
        if (readBio) {
          bioContainer.style.height = bioContainer.scrollHeight + "px";
          this.classList.remove('btn-plus-icon');
          this.classList.add('btn-minus-icon');
        } else {
          bioContainer.style.height = null;
          this.classList.remove('btn-minus-icon');
          this.classList.add('btn-plus-icon');
        }
        readBio = false;
      });
    });
 
    function closeAllBio(bioInfos) {
      for (var bioInf = 0; bioInf < bioInfos.length; bioInf++) {
        bioInfos[bioInf].previousElementSibling.style.height = null;
        bioInfos[bioInf].classList.remove('btn-minus-icon');
        bioInfos[bioInf].classList.add('btn-plus-icon');
      }
    }
  })
}
      }
    }
})(jQuery, Drupal, once, drupalSettings);